<h2 mat-dialog-title class="dialog-header">
  <div class="header-left">
    <mat-icon class="header-icon">history</mat-icon>
    WORKFLOW HISTORY
  </div>
  <button type="button" aria-label="Close" (click)="onCancelClick()" class="close-button">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<!-- No data message -->
<div *ngIf="dataSource!.data.length == 0" class="no-data">
  No History Available
</div>
<mat-dialog-content *ngIf="dataSource!.data.length">
  <p><strong>Instance ID:</strong>
    <mat-form-field appearance="fill" class="custom-select">
      <mat-select [(value)]="selectedInstanceID" name="InstanceID" (selectionChange)="updateHistory(selectedInstanceID)">
        <ng-container>
          <mat-option *ngFor="let instance of instanceIdOptions" [value]="instance.value">{{ instance.text }}</mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>
  </p>
  <div class="top">
    <div class="row-split">
      <p><strong>Document ID:</strong> {{ instanceData!.parentDocumentId }}</p>
      <p><strong>Batch ID:</strong> {{ instanceData!.batchId }}</p>
    </div>
    <div class="row-split">
      <p><strong>Finishing Date:</strong> {{ instanceData!.finishDate }}</p>
      <p><strong>Create Date:</strong> {{ instanceData!.entryDate }}</p>
      <p><strong>Finishing User:</strong> {{ instanceData!.finishingUser }}</p>
    </div>
  </div>
  <div class="bottom"  *ngIf="dataSource!.data.length">
    <!-- Table shown only if there is data -->
    <table mat-table [dataSource]="dataSource|| []" matSort class="mat-elevation-z8">

      <ng-container matColumnDef="moveDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header  style="width: 12%;">Action Date</th>
        <td mat-cell *matCellDef="let row">{{ row.moveDate }}</td>
      </ng-container>

      <ng-container matColumnDef="fromPA">
        <th mat-header-cell *matHeaderCellDef mat-sort-header  style="width: 12%;">From Queue</th>
        <td mat-cell *matCellDef="let row">{{ row.fromPA }}</td>
      </ng-container>

      <ng-container matColumnDef="toPA">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 12%;">To Queue</th>
        <td mat-cell *matCellDef="let row">{{ row.toPA }}</td>
      </ng-container>

      <ng-container matColumnDef="userName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 12%;">User Gpid</th>
        <td mat-cell *matCellDef="let row">{{ row.userName }}</td>
      </ng-container>

      <ng-container matColumnDef="displayUserName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 12%;">User Name</th>
        <td mat-cell *matCellDef="let row">{{ row.displayUserName }}</td>
      </ng-container>

      <ng-container matColumnDef="workflowAction">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 12%;">Action</th>
        <td mat-cell *matCellDef="let row">{{ row.workflowAction }}</td>
      </ng-container>

      <ng-container matColumnDef="userComments">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 16%;">Comments</th>
        <td mat-cell *matCellDef="let row">{{ row.userComments }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
</mat-dialog-content>